<template>
	<v-card class="mt-3 ma-2">
		<v-toolbar :color="color" dark>
			<v-toolbar-title class="no-print">{{ header }}</v-toolbar-title>
			<h3 class="d-none print-only ma-2 black--text">{{ header }}</h3>
			<v-spacer></v-spacer>
			<v-btn v-if="!readOnly" @click="$refs.fileInput.click()" icon class="no-print">
				<v-icon>add</v-icon>
			</v-btn>

			<input @change="uploadFile" ref="fileInput" id="fileInput" type="file" v-show="false"
				:accept="acceptedFiles"
				aria-label="label for document">
		</v-toolbar>

		<v-list two-line>
			<template v-for="(item, index) in documents">
				<v-list-tile :key="item.id" avatar class="protocol-document-list-item">
					<v-list-tile-avatar>
						<v-icon>assignment</v-icon>
					</v-list-tile-avatar>

					<v-list-tile-content>
						<v-list-tile-title>{{item.fileName}}</v-list-tile-title>
						<template v-if="!readOnly">
							<v-list-tile-sub-title>{{displayDateTime(item.creationDate)}}</v-list-tile-sub-title>
							<!-- <v-list-tile-action-text v-html="getContestFileUrl(item.id)"></v-list-tile-action-text> -->
						</template>
					</v-list-tile-content>

					<v-list-tile-action class="no-print">
						<EgrantyIconButton 
							@click="downloadFile(item)" 
							icon="cloud_download" 
							color="primary" 
							label="pobierz"
						/>
					</v-list-tile-action>

					<v-list-tile-action class="no-print" v-if="!readOnly">
						<EgrantyIconButton 
							@click="deleteFile(item, index)" 
							icon="delete" 
							color="lightred" 
							label="usuń"
						/>
					</v-list-tile-action>
				</v-list-tile>
			</template>
		</v-list>
	</v-card>
</template>

<script>
	import {Dates} from "@/utils/Dates";
	import {Files} from "@/utils/Files";
	import {Api} from "@/api";
	import {Library} from "@/api/generated/Library";
	import EgrantyIconButton from "@/genericComponents/EgrantyIconButton";

	export default {
		name: "LibraryList",

		components: {
			EgrantyIconButton
		},

		data() {
			return {};
		},

		props: {
			color: String,
			header: String,
			contestId: String,
			libraryUserRoleType: String,
			documents: Array,
			readOnly: {
				type: Boolean,
				default: false
			}
		},

		methods: {
			downloadFile(file) {
				this.downloadLibraryFile(this, file.id, file.fileName);
			},

			deleteFile(file, index) {
				Library.delete(this, file.id,
					successResponse => {
						this.$delete(this.documents, index);
						this.$messagesBus.$emit("success", "Dokument został usunięty", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się poprawnie usunąć dokumentu", errorResponse);
					});
			},

			async uploadFile() {
				if (this.hasIncorrectFilesExtension(this.$refs.fileInput.files)) {
					Files.methods.clearFileInput('fileInput');
					this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
						"Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
					return;
				}
				let validFilesSize = await Files.methods.validateFilesSize(this, this.$refs.fileInput.files);
				if (!validFilesSize) {
					Files.methods.clearFileInput('fileInput');
					return;
				}
				Api.postMultipart(this, "/library", this.$refs.fileInput.files[0],
					{
						"libraryUserRoleType": this.libraryUserRoleType,
					},
					successResponse => {
						this.documents.push(successResponse);
						Files.methods.clearFileInput('fileInput');
						this.$messagesBus.$emit("success", "Dokument został dodany", successResponse);
					},
					errorResponse => {
						Files.methods.clearFileInput('fileInput');
						this.$messagesBus.$emit("error", "Nie udało się poprawnie dodać dokumentu", errorResponse);
					});
			},
		},

		mixins: [
			Dates,
			Files,
		],
	};
</script>

<style scoped>
	.theme--dark .v-toolbar {
		background-color: #0052a5 !important;
	}
	.theme--dark .v-list__tile__action-text {
		color: #fff;
	}
	.theme--dark .red--text.text--lighten-1 {
		color: yellow !important;
	}
</style>
